
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useCountryRestrictions = () => {
  const [userCountry, setUserCountry] = useState<string | null>(null);
  const [blockedExchanges, setBlockedExchanges] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountryInfo = async () => {
      try {
        setLoading(true);
        
        // Get user's country from the get-client-info function
        const { data: clientInfo, error: clientError } = await supabase.functions.invoke('get-client-info');
        
        if (clientError) {
          console.error('Error fetching client info:', clientError);
          return;
        }

        const countryCode = clientInfo.country_code3;
        setUserCountry(countryCode);

        // Get blocked exchanges for the user's country
        if (countryCode) {
          const { data: blockedData, error: blockedError } = await supabase
            .from('country_blocklist')
            .select('exchange')
            .eq('iso_code', countryCode);

          if (blockedError) {
            console.error('Error fetching blocked exchanges:', blockedError);
            return;
          }

          setBlockedExchanges(blockedData?.map(item => item.exchange) || []);
        }
      } catch (error) {
        console.error('Error in useCountryRestrictions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountryInfo();
  }, []);

  return {
    userCountry,
    blockedExchanges,
    loading,
    isExchangeBlocked: (exchange: string) => blockedExchanges.includes(exchange)
  };
};
